/**
 * @file Automatically generated by barrelsby.
 */

export * from './footer.component';
export * from './resolvers/index';
